import actions from '../../../generalActions/generalActions.js'

export default {
    props: ['content'],
    computed: {
        context() {
            return this.$store.state.context
        }
    },
    methods: {
        async closeShowMessage() {
            await this.$store.dispatch('chatState', false)
            await this.$store.dispatch('bubbleMessageAfterClose')
        },
        action(actionObj) {
            actions.action(this, actionObj)
        },
        fillPlaceholders(answer, obj) {
            return answer.replace(/({{[A-Za-z0-9_.]*}})/g, function(element) {
                element = element.slice(2, -2)
                let props = element.split('.')
                if (obj.hasOwnProperty(props[0])) {
                    let res = obj
                    try {
                        for (let prop of props) {
                            res = res[prop]
                        }
                    } catch (err) {
                        res = element
                    }
                    return res
                } else {
                    return element
                }
            })
        },
        nRender(h, content) {
            let that = this
            if (typeof content === 'string') {
                return content
            } else if (Array.isArray(content)) {
                return content.map(function(answer) {
                    if (typeof answer === 'string') {
                        return answer
                    } else if (!Array.isArray(answer) && typeof answer === 'object' && answer !== null) {
                        if (answer.tag) {
                            if (answer.tag === 'br') {
                                return h('br')
                            } else if (['b', 'i', 'mark', 'small', 'del', 'ins', 'sub', 'sup', 'p', 'div'].includes(answer.tag)) {
                                return h(answer.tag, that.nRender(h, answer.content))
                            } else if (answer.tag === 'ul' || answer.tag === 'ol') {
                                return h(answer.tag, answer.content.map(function(element) {
                                    return h('li', that.nRender(h, element))
                                }))
                            } else if (answer.tag === 'a') {
                                if (answer.hasOwnProperty('action') || answer.hasOwnProperty('actions')) {
                                    // si entre las acciones está open y se quiere cerrar el chat, agregar después de la accion open la accion closeChat
                                    return h('span', {
                                        class: 'link',
                                        on: { click() { that.action(answer) } }
                                    }, that.nRender(h, answer.text))
                                } else if (answer.hasOwnProperty('href')) {
                                    let args = { attrs: { href: answer.href } }
                                    if (answer.hasOwnProperty('target')) {
                                        args.attrs.target = answer.target
                                        if (answer.target === '_self') {
                                            args.on = { click() { that.closeShowMessage() } }
                                        }
                                    } else {
                                        args.on = { click() { that.closeShowMessage() } }
                                    }
                                    return h('a', args, that.nRender(h, answer.text))
                                }
                            } else if (answer.tag === 'img') {
                                if (answer.style == null) answer.style = {}
                                if (!answer.style.hasOwnProperty('vertical-align')) {
                                    answer.style['vertical-align'] = 'middle'
                                }
                                return h('img', { attrs: { src: answer.src }, style: answer.style })
                            } else {
                                return answer.content.toString
                            }
                        } else if (answer.contextAction) {
                            if (answer.contextAction === 'formatList') {
                                if (['ul', 'ol'].includes(answer.args.container)) {
                                    let answerList = that.context[answer.args.contextVar].map(function(element, index) {
                                        element._arrayIndex = index
                                        let elContent = JSON.parse(that.fillPlaceholders(JSON.stringify(answer.args.content), element))
                                        return h('li', that.nRender(h, elContent))
                                    })
                                    return h(answer.args.container, answerList)
                                } else {
                                    let answerList = that.context[answer.args.contextVar].map(function(element, index) {
                                        element._arrayIndex = index
                                        let elContent = JSON.parse(that.fillPlaceholders(JSON.stringify(answer.args.content), element))
                                        return that.nRender(h, elContent)
                                    })
                                    return h('span', answerList)
                                }
                            }
                        } else if (answer.util) {
                            if (answer.util === 'toCurrency') {
                                let re = '\\d(?=(\\d{3})+' + (answer.args.decimals > 0 ? '\\D' : '$') + ')'
                                let num = parseFloat(answer.args.number).toFixed(Math.max(0, ~~answer.args.decimals))
                                return (answer.args.decimalDelimiter ? num.replace('.', answer.args.decimalDelimiter) : num.replace('.', ','))
                                    .replace(new RegExp(re, 'g'), '$&' + (answer.args.thousandDelimiter || '.'))
                            } else if (answer.util === 'ternary') {
                                if (answer.args.if_variable === 'true') {
                                    return that.nRender(h, answer.args.if_content)
                                } else {
                                    return that.nRender(h, answer.args.else_content)
                                }
                            } else if (answer.util === 'formatList') {
                                if (['ul', 'ol'].includes(answer.args.container)) {
                                    let answerList = that.context[answer.args.contextVar].map(function(element, index) {
                                        element._arrayIndex = index
                                        let elContent = JSON.parse(that.fillPlaceholders(JSON.stringify(answer.args.content), element))
                                        return h('li', that.nRender(h, elContent))
                                    })
                                    return h(answer.args.container, answerList)
                                } else {
                                    let answerList = that.context[answer.args.contextVar].map(function(element, index) {
                                        element._arrayIndex = index
                                        let elContent = JSON.parse(that.fillPlaceholders(JSON.stringify(answer.args.content), element))
                                        return that.nRender(h, elContent)
                                    })
                                    return h('span', answerList)
                                }
                            } else if (answer.util === 'randomMessage') {
                                let msgs = answer.args.messages
                                let msg = msgs[Math.floor(Math.random() * msgs.length)]
                                return that.nRender(h, msg)
                            }
                        }
                    }
                    return ''
                })
            }
            return h('span', '')
        }
    },
    render(h) {
        return h('span', this.nRender(h, this.content))
    }
}


// WEBPACK FOOTER //
// ./src/components/widgets/ContentRender/ContentRender.js